var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgESigning = function SvgESigning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#e-signing_svg__a)",
    rx: 16
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e-signing_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e-signing_svg__c",
    width: 24,
    height: 24,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h24v24H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e-signing_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.186 20.921 8.308-8.308a.22.22 0 0 0 .067-.163.22.22 0 0 0-.067-.164l-.973-.973a.22.22 0 0 0-.163-.067.22.22 0 0 0-.164.067l-8.307 8.308zm-9.244-1.637q0 .813.558 1.27t1.785.611a.72.72 0 0 1 .488.276q.185.236.17.54a.76.76 0 0 1-.228.527.58.58 0 0 1-.507.167q-1.872-.231-2.818-1.08-.948-.85-.948-2.31 0-1.52 1.275-2.465t3.545-1.145q1.09-.094 1.635-.394t.545-.831q0-.655-.568-1.03t-1.864-.57a.75.75 0 0 1-.498-.279.68.68 0 0 1-.154-.542.78.78 0 0 1 .278-.52.66.66 0 0 1 .55-.15q1.913.291 2.834 1.05.922.76.922 2.04 0 1.192-.914 1.888-.915.697-2.655.838-1.715.145-2.573.67t-.858 1.44m9.479 3.525-3.423-3.423 9.339-9.328a1.4 1.4 0 0 1 1.033-.438q.591.005 1.034.438l1.346 1.346q.442.442.442 1.038t-.442 1.039zm-3.34.69a.6.6 0 0 1-.596-.176.6.6 0 0 1-.177-.596l.69-3.34 3.423 3.422z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e-signing_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e-signing_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgESigning);
export default ForwardRef;